import {
  PAGE_HOME,
  PAGE_RESEARCH,
  PAGE_ENGINEERING,
  PAGE_SIMULATION,
  PAGE_OUTPUTS,
  PAGE_BUILD,
  PAGE_JOURNAL,
} from '../constants/pages';

import {
  JOURNAL_INTRO,
  JOURNAL_DESIGN_CHALLENGE,
  JOURNAL_GRADEBOOK,
  JOURNAL_LOGS,
  JOURNAL_REFLECTION,
} from '../constants/journal';

/**
 * Converts page constants to human-readable page names for announcements
 * @param {string} page - Page constant (e.g., PAGE_RESEARCH)
 * @returns {string} Human-readable page name
 */
export const getPageName = (page) => {
  const pageNames = {
    [PAGE_HOME]: 'Home',
    [PAGE_RESEARCH]: 'Research',
    [PAGE_ENGINEERING]: 'Engineering',
    [PAGE_SIMULATION]: 'Competition',
    [PAGE_OUTPUTS]: 'Outputs',
    [PAGE_BUILD]: 'Build',
    [PAGE_JOURNAL]: 'Journal',
  };

  return pageNames[page] || page;
};

/**
 * Converts journal page constants to human-readable names for announcements
 * @param {string} page - Journal page constant (e.g., JOURNAL_INTRO)
 * @returns {string} Human-readable journal page name
 */
export const getJournalPageName = (page) => {
  const journalPageNames = {
    [JOURNAL_INTRO]: 'Introduction',
    [JOURNAL_DESIGN_CHALLENGE]: 'Design Challenge',
    [JOURNAL_GRADEBOOK]: 'Gradebook',
    [JOURNAL_LOGS]: 'Engineering Logs',
    [JOURNAL_REFLECTION]: 'Final Reflection',
  };

  return journalPageNames[page] || page;
};
